import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Card } from "reactstrap";
import ReactStars from "react-rating-stars-component";
import { ProfileService } from "../../services/ProfileService";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import smartresume from "../../assets/img/images/review_smartresume 2.png";
import { isNullOrEmpty } from "../../config/ENV";
import { getDateDifference } from "../../utilities/durationutility";
import SvgSkillCheck from "../../../src/components/svg/svgskillcheck";
import SvgCertificationBadge from "../../components/svg/svgcertificationbadge";
import { formattedMobileNumber } from "../../utilities/phonenumberutility";
import sortArray from "sort-array";
import squarebullet from "../../assets/img/images/Bullet-Square.png";
import { Stringutility } from "../../utilities/stringutility";
import { StorageService } from "../../services/StorageService";
import { StorageValues } from "../../constants/storageValues";

const Review = () => {
  const history = useHistory();
  const [basicInfo, setBasicInfo] = useState({});
  const [experienceList, setExperienceList] = useState([]);
  const [educationList, setEducationList] = useState([]);
  const [skillsList, setSkillsList] = useState([]);
  const [files, setFiles] = useState([]);

  const [certifications, setCertifications] = useState([]);
  const [softSkills, setSoftSkills] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [highLights, setHighLights] = useState({});

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [tagLine, setTagLine] = useState("");

  const [city, setCity] = useState("");
  const [state, setState] = useState("");

  const [careerHighlights, setCareerHighlights] = useState([]);

  const [filteredExperienceList, setFilteredExperienceList] = useState([]);
  const [filterededuList, setFilterededuList] = useState([]);

  const filterExperience = (exp) => {
    var x = exp.filter((expItem) => expItem.endDate === 0);
    var p1 = sortArray(x, { by: "startDate", order: "desc" });

    var y = exp.filter(
      (expItem) => expItem.endDate !== 0 && expItem.startDate !== 0
    );
    var z = exp.filter((expItem) => expItem.startDate === 0);

    setFilteredExperienceList([...z, ...p1, ...y]);
  };

  const filterEdu = (eduList) => {
    var x1 = eduList.filter((expItem) => expItem.endDate === 0);
    var p2 = sortArray(x1, { by: "startDate", order: "desc" });
    var y1 = eduList.filter(
      (expItem) => expItem.endDate !== 0 && expItem.startDate !== 0
    );
    var p3 = sortArray(y1, { by: "endDate", order: "desc" });
    var z1 = eduList.filter((expItem) => expItem.startDate === 0);
    setFilterededuList([...z1, ...p2, ...p3]);
  };

  useEffect(() => {
    getCandidateReviewDetails();
  }, []);

  const getCandidateReviewDetails = () => {
    ProfileService.getCandidateReview().then((response) => {
      try {
        if (response.data != null) {
          const candidateReviewDetails = response.data;
          if (candidateReviewDetails != null) {
            let basicInfoDetails = candidateReviewDetails.basicInfo;
            if (basicInfoDetails != null) {
              setBasicInfo(basicInfoDetails);
              let firstName = Stringutility.getValue(
                basicInfoDetails.firstName
              );
              setFirstName(firstName);
              let lastName = Stringutility.getValue(basicInfoDetails.lastName);
              setLastName(lastName);

              let address = basicInfoDetails.address;
              if (address != null) {
                let city = Stringutility.getValue(address.city);
                setCity(city);
                let state = Stringutility.getValue(address.state);
                setState(state);
              }
            }

            const eduListDetails = candidateReviewDetails.eduList;
            if (eduListDetails != null) {
              const eduList = eduListDetails.eduList;
              if (eduList != null) {
                setEducationList(eduList);
                filterEdu(eduList);
              }
            }

            const expListDetails = candidateReviewDetails.expList;
            if (expListDetails != null) {
              const exps = expListDetails.exps;
              if (exps != null) {
                setExperienceList(exps);
                filterExperience(exps);
              }
            }

            const skillsDetails = candidateReviewDetails.skills;
            if (skillsDetails != null) {
              const skills = skillsDetails.skills;
              if (skills != null) {
                setSkillsList(skills);
              }
            }

            const certificationDetails = candidateReviewDetails.certifications;
            if (certificationDetails != null) {
              const certificationSkills = certificationDetails.skills;
              if (certificationSkills != null) {
                setCertifications(certificationSkills);
              }
            }

            const softSkillDetails = candidateReviewDetails.softSkills;
            if (softSkillDetails != null) {
              const softSkillSkills = softSkillDetails.skills;
              if (softSkillSkills != null) {
                setSoftSkills(softSkillSkills);
              }
            }

            const languageDetails = candidateReviewDetails.langs;
            if (languageDetails != null) {
              const languages = languageDetails.languages;
              if (languages != null) {
                setLanguages(languages);
              }
            }

            const fileDetails = candidateReviewDetails.files;
            if (fileDetails != null) {
              const files = fileDetails.files;
              if (files != null) {
                setFiles(files);
              }
            }

            const highlights = candidateReviewDetails.highlights;
            if (highlights !== null) {
              setHighLights(highlights);
              const tagLine = highlights.tagline;
              if (!Stringutility.isNullOrEmpty(tagLine)) {
                setTagLine(tagLine);
              }

              const carrierHighlights = highlights.highlights;
              if (carrierHighlights !== null) {
                setCareerHighlights(carrierHighlights);
              }
            }
          }
        }
      } catch (err) {
        console.error("getCandidateReview" + JSON.stringify(err));
      }
    });
  };

  const showCityState = (address) => {
    const add = [];
    if (!Stringutility.isNullOrEmpty(address)) {
      let city = Stringutility.getValue(address.city);
      if (city != "") {
        add.push(city);
      }

      let state = Stringutility.getValue(address.state);
      if (state != "") {
        add.push(state);
      }
    }
    return add.join(", ");
  };

  const showMonthYear = (notecreatedOn) => {
    if (notecreatedOn === 0) {
      return "";
    }
    var date = new Date(notecreatedOn);
    const dateArr = date.toLocaleString().split(" ");

    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[date.getMonth()] + " " + date.getFullYear();
  };

  return (
    <div className="bodyContent 2Grid min-md:grid gap-10 min-h-[420px] min-md:grid-cols-8 min-lg:grid-cols-12 max-md:flex max-md:flex-col-reverse p-3 t-p-3">
      <div className="Col1 min-sm:col-span-3 rounded-lg ">
        <div className="graphicCol ">
          <img className="w-full  " src={smartresume} alt="" />

          <div className="smartresumeInfo">
            <div className="description rounded-xl my-6">
              <h2 className="text-xl font-bold pb-[0.125rem] t-pb-pad">
                <strong>What is a Smart Resume</strong>
              </h2>
              <div className="text-base text-primary-dark">
                <p className="pb-2">
                  This is how the employer views your skills and experiences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="Col2 min-sm:col-span-5 min-lg:col-span-9 rounded-lg border-l-primary-gray2 min-lg:border-l min-sm:pl-7 min-lg:pl-10 t-pading-left-smart">
        <div className="">
          <h1 className="font-bold text-2xl pb-4 t-pb-4 max-sm:pb-4 t-pb-pad">
            {" "}
            Smart Resume™ Review
          </h1>
          <div>
            <div className="mb-1  pb-4">
              You can add anything you missed by going to the previous steps.
              Wait until later to fix any scanning errors.
            </div>
            <>
              <div className=" min-sm:col-span-2 max-sm:col-span-full">
                <div className="smartResume-container relative min-sm:grid min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg pt-12 mb-8">
                  <div className="pencilUpdate absolute top-12 right-9 max-sm:-top-[58px] "></div>

                  <div className="smartIntro min-sm: mb-4 max-sm:mb-8 min-sm:border-l-4 border-primary-blue min-sm:px-12 basis-full order-1 col-span-4 row-start-1 t-name-left">
                    <div className="Name max-sm:px-7 t-name-pad">
                      <div className="font-normal text-3xl">
                        {firstName} {lastName}
                      </div>
                    </div>

                    <div className="col">
                      <div className="row t-mail-align">
                        <div className="mr-2 mt-1">
                          <div className="title ">
                            <AiOutlineMail />
                          </div>
                        </div>
                        <div className="">
                          {
                           Stringutility.getValue(StorageService.getFromLocalStorage(StorageValues.EMAIL))}
                        </div>
                      </div>
                    </div>

                    <div className="col">
                      <div className="row t-mail-align">
                        <div className="mr-2 mt-1">
                          <div className="form-review ">
                            <BsTelephone />
                          </div>
                        </div>
                        <div className="">
                          {formattedMobileNumber(basicInfo.contactNumber)}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="min-sm:px-12 mb-6 min-sm:col-start-2 min-sm:col-end-4 max-sm:px-7">
                    <span>
                      <div className="row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 mt-2 ml-0">
                        <h2 className="font-bold text-lg">Career Highlights</h2>
                        &nbsp;
                      </div>
                    </span>

                    <div className="career flex flex-row text-sm ">
                      <div>
                        <div className="career flex flex-row text-sm ">
                          <div>
                            {!isNullOrEmpty(tagLine) && (
                              <ul>
                                <li className="flex ">
                                  {/* <SvgTagLine /> */}
                                  <img
                                    src={squarebullet}
                                    className="t-bullet-size mr-2"
                                  ></img>
                                  <div> {tagLine}</div>
                                </li>
                              </ul>
                            )}

                            {careerHighlights.length > 0 &&
                              careerHighlights.map((highlights, index) => {
                                return (
                                  <div key={index}>
                                    <ul>
                                      <li className="flex my-3">
                                        <img
                                          src={squarebullet}
                                          className="t-bullet-size mr-2"
                                        ></img>
                                        <div>{highlights}</div>
                                      </li>
                                    </ul>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="Skills max-sm:mb-10">
                      <span>
                        <div className="row  border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0 t-skill-names-pad">
                          <h2 className="font-bold text-lg">Skills</h2>&nbsp;
                        </div>
                      </span>

                      <div>
                        <div className="tab-content" id="tabs-tabContent">
                          <div
                            className="tab-pane fade show active"
                            id="tabs-jobrelated"
                            role="tabpanel"
                            aria-labelledby="tabs-jobrelated-tab"
                          >
                            <div className="flex flex-wrap gap-3 items-center font-normal text-sm mt-4">
                              {skillsList.length > 0 &&
                                skillsList.map((skills, index) => {
                                  return (
                                    <div
                                      className="basis-[48%] py-3 text-center bg-primary-gray rounded-xl t-basis-wid"
                                      key={index}
                                    >
                                      <div className="">{skills.name}</div>

                                      <div className="text-center items-center justify-center inline-block my-2">
                                        <Card className="star_bg_color col-12">
                                          <ReactStars
                                            count={5}
                                            edit={false}
                                            size={16}
                                            value={skills.rating}
                                            id={skills.id + "_rating"}
                                            activeColor="rgb(255, 188, 59)"
                                          ></ReactStars>
                                        </Card>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="tabs-additional"
                            role="tabpanel"
                            aria-labelledby="tabs-additional-tab"
                          >
                            Tab 2 content
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="px-7 min-sm:px-12 min-sm:col-span-2 min-sm:col-start-2 min-sm:row-start-3 min-sm:row-span-3 t-padding-resume">
                      <span>
                        <div className="row border-b-2 border-primary-blue2 border-solid pb-1 ml-0">
                          <h2 className="font-bold text-lg">Job Experience</h2>
                          &nbsp;
                        </div>
                      </span>

                      <div className="my-3">
                        {filteredExperienceList.length > 0 &&
                          filteredExperienceList.map((experience, index) => {
                            return (
                              <div key={index}>
                                <div className="relative max-sm:mb-12 py-2">
                                  <h3 className="font-semibold text-lg text-primary-blue pragrap_pad">
                                    {experience.position}
                                  </h3>
                                  <p className="pragrap_pad">
                                    {experience.employer}
                                  </p>
                                  {!isNullOrEmpty(experience.address) && (
                                    <p className="pragrap_pad">
                                      {showCityState(experience.address)}
                                    </p>
                                  )}
                                  <p className="fnt_semibold text-sm pragrap_pad">
                                    {experience.startDate == 0 ? (
                                      <></>
                                    ) : (
                                      <>
                                        {experience.startDate !== 0 &&
                                        experience.endDate == 0 ? (
                                          <>
                                            {showMonthYear(
                                              experience.startDate
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {showMonthYear(
                                              experience.startDate
                                            )}{" "}
                                            -{" "}
                                            {showMonthYear(experience.endDate)}
                                          </>
                                        )}
                                      </>
                                    )}{" "}
                                    {experience.startDate == 0 ||
                                    experience.endDate == 0 ? (
                                      <></>
                                    ) : (
                                      <>
                                        (
                                        {getDateDifference(
                                          experience.startDate,
                                          experience.endDate
                                        )}
                                        )
                                      </>
                                    )}
                                  </p>

                                  {experience.description == "" ? (
                                    <></>
                                  ) : (
                                    <ul
                                      disabled
                                      className="mt-3 font-normal text-sm text-neutral-700 bg-primary-lightblue rounded-xl px-7 py-3 list-disc t-parsed-text"
                                    >
                                      {experience.description}
                                    </ul>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>

                    <div className="min-sm:px-12 mb-6 min-sm:col-start-2 min-sm:col-end-4 max-sm:px-7 t-padding-resume">
                      <span>
                        <div className="row border-b-2 border-primary-blue2 border-solid pb-1 ml-0">
                          <h2 className="font-bold text-lg">Education</h2>
                          &nbsp;
                        </div>
                      </span>

                      <div className="my-3">
                        {filterededuList.length > 0 &&
                          filterededuList.map((education, index) => {
                            return (
                              <div key={index}>
                                <div className="relative max-sm:mb-12 py-2">
                                  <h3 className="fnt_semibold text-lg text-primary-blue pragrap_pad">
                                    {education.major}
                                  </h3>
                                  <p className="pragrap_pad">
                                    {education.school}
                                  </p>
                                  {education.address != null ? (
                                    <>
                                      {" "}
                                      <p className="pragrap_pad">
                                        {showCityState(education.address)}
                                      </p>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  <p className="fnt_semibold text-sm pragrap_pad">
                                    {education.endDate == 0 ? (
                                      <></>
                                    ) : (
                                      <>
                                        {education.startDate == 0 &&
                                        education.endDate !== 0 ? (
                                          <>
                                            {showMonthYear(education.endDate)}
                                          </>
                                        ) : (
                                          <>
                                            {showMonthYear(education.startDate)}{" "}
                                            - {showMonthYear(education.endDate)}
                                          </>
                                        )}
                                      </>
                                    )}{" "}
                                    {education.startDate == 0 ||
                                    education.endDate == 0 ? (
                                      <></>
                                    ) : (
                                      <>
                                        (
                                        {getDateDifference(
                                          education.startDate,
                                          education.endDate
                                        )}
                                        )
                                      </>
                                    )}
                                  </p>

                                  {education.description == "" ? (
                                    <></>
                                  ) : (
                                    <ul className="mt-3 font-normal text-sm text-neutral-700 bg-primary-lightblue rounded-xl px-7 py-3 list-disc t-parsed-text">
                                      {education.description}
                                    </ul>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>

                  <div className="px-7 max-sm:mb-10 min-sm:bg-primary-lightblue min-sm:py-7 min-sm:my-0 min-sm:col-start-1 min-sm:row-start-2 t-lightblue-pad">
                    <span>
                      <div className=" row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0 t-skill-names-pad t-line-padding-right">
                        <h2 className="font-bold text-lg t-text-pad-smart">
                          Soft Skills
                        </h2>
                        &nbsp;
                      </div>
                    </span>

                    <div className="flex flex-wrap gap-3 flex-row min-sm:flex-col font-normal text-sm ">
                      {softSkills.length > 0 &&
                        softSkills.map((softskill, index) => {
                          return (
                            <div
                              className="basis-[48%] soft_wrap t-reported-align"
                              key={index}
                            >
                              <SvgSkillCheck />

                              {softskill.name}
                            </div>
                          );
                        })}
                    </div>
                    {softSkills.length == null || softSkills.length == "" ? (
                      <></>
                    ) : (
                      <>
                        <div className="flex flex-nowrap flex-row items-center t-black-box-pad bg-primary-lightblue rounded-xl font-semibold text-sm max-sm:flex-row max-sm:px-2 min-sm:items-start min-sm:w-[70%] min-sm:flex-col min-sm:px-2 min-sm:py-2  min-sm:text-white min-sm:bg-neutral-700 box_wid t-balckbox-top-pad flex flex-nowrap flex-row items-center t-black-box-pad bg-primary-lightblue rounded-xl font-semibold text-sm max-sm:flex-row max-sm:px-2 min-sm:items-start min-sm:w-[70%] min-sm:flex-col min-sm:px-2 min-sm:py-2  min-sm:text-white min-sm:bg-neutral-700 box_wid t-black-box-color">
                          <div className="col">
                            <div className="row">
                              <div>
                                <SvgSkillCheck /> Self reported
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="px-7 max-sm:mb-10 min-sm:bg-primary-lightblue min-sm:py-7 min-sm:col-start-1 min-sm:row-start-3 t-padding-resume">
                      <span>
                        <div className="row  border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0 t-skill-names-pad t-line-padding-right">
                          <h2 className="font-bold text-lg t-text-pad-smart">
                            Languages
                          </h2>
                          &nbsp;
                        </div>
                      </span>

                      <div className="flex flex-wrap gap-3 font-normal text-sm min-sm:flex-col t-lang-wid-pad t-flex t-flex-wrap">
                        {languages.length > 0 &&
                          languages.map((language, index) => {
                            return (
                              <div
                                className="basis-[48%] py-3 text-center bg-primary-gray rounded-xl min-sm:bg-white"
                                key={index}
                              >
                                {language.ratingSpoken ? (
                                  <>
                                    <div>{language.description} Spoken</div>

                                    <div className="inline-block text-center items-center justify-center my-2">
                                      <Card className="star_bg_color col-12">
                                        <ReactStars
                                          classNames="clr_star"
                                          count={5}
                                          edit={false}
                                          size={16}
                                          activeColor="rgb(255, 188, 59)"
                                          value={language.ratingSpoken}
                                          id={language.id + "_rating"}
                                        ></ReactStars>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {language.ratingWritten ? (
                                  <>
                                    <div>{language.description} Written</div>

                                    <div className="inline-block text-center items-center justify-center my-2">
                                      <Card className="star_bg_color col-12">
                                        <ReactStars
                                          classNames="clr_star"
                                          count={5}
                                          edit={false}
                                          size={16}
                                          activeColor="rgb(255, 188, 59)"
                                          value={language.ratingWritten}
                                          id={language.id + "_rating"}
                                        ></ReactStars>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <div className="px-7 max-sm:mb-10 min-sm:bg-primary-lightblue min-sm:py-7 min-sm:col-start-1 min-sm:row-start-4 t-padding-resume mb-5">
                      <span>
                        <div className="row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0 t-skill-names-pad t-line-padding-right">
                          <h2 className="font-bold text-lg t-text-pad-smart">
                            Certificates
                          </h2>
                          &nbsp;
                        </div>
                      </span>

                      <div className="text-sm">
                        {certifications.length > 0 &&
                          certifications.map((certifications, index) => {
                            return (
                              <div key={index} className="t-reported-align">
                                <ul>
                                  <li className="my-3 ">
                                    <SvgCertificationBadge />
                                    {certifications.name}
                                  </li>
                                </ul>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <div className="px-7  min-sm:bg-primary-lightblue min-sm:py-7 min-sm:col-start-1 min-sm:row-start-5 t-padding-resume mb-5">
                      <span>
                        <div className="row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0 t-skill-names-pad t-line-padding-right">
                          <h2 className="font-bold text-lg t-text-pad-smart ">
                            Original Resume
                          </h2>
                          &nbsp;
                        </div>
                      </span>

                      <div className="mb-10">
                        {files.length > 0 &&
                          files.map((Files, index) => {
                            return (
                              <form
                                action=""
                                encType=""
                                method=""
                                className="relative"
                                key={index}
                              >
                                <div className="row">
                                  {" "}
                                  &nbsp;&nbsp;&nbsp;
                                  <div className=" mr-2 ml-3 mt-1">
                                    <a href={Files.fileKey}>
                                      <span>
                                        {" "}
                                        <FaCloudDownloadAlt
                                          title="Download Resume"
                                          color="black"
                                          className="emp_icon"
                                        />
                                      </span>
                                    </a>
                                  </div>
                                  <div className="">
                                    <span>{Files.name}</span>
                                  </div>
                                </div>
                              </form>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Review;
